(() => {
  const controllers = new Map();
  function mount(host) {
    if (controllers.has(host)) return;
    const toggle = host.querySelector('.zpg-tzero-toggle');
    const bubble = host.querySelector('[data-tzero-speech]');
    let lines;
    try { lines = JSON.parse(host.querySelector('[data-tzero-sayings]').textContent); }
    catch { lines = bubble.textContent; }
    const sayings = String(lines).split(/\r?\n/).map(line => line.replace(/&amp;/g, '&').replace(/&#39;|&#x27;|&apos;/gi, "'").replace(/&quot;/g, '"').trim()).filter(Boolean).slice(0, 10);
    let paused = false, visible = true, timer, sayingIndex = 0;
    function schedule() {
      clearTimeout(timer);
      const running = !paused && visible && !document.hidden && host.isConnected;
      host.dataset.paused = String(paused);
      host.dataset.running = String(running);
      toggle.setAttribute('aria-pressed', String(paused));
      toggle.setAttribute('aria-label', paused ? host.dataset.playLabel : host.dataset.pauseLabel);
      toggle.title = paused ? host.dataset.playLabel : host.dataset.pauseLabel;
      toggle.textContent = paused ? '▶' : 'Ⅱ';
      if (running && sayings.length > 1) timer = setTimeout(() => {
        sayingIndex = (sayingIndex + 1) % sayings.length;
        bubble.textContent = sayings[sayingIndex];
        schedule();
      }, 8000);
    }
    const click = () => { paused = !paused; schedule(); };
    const pagehide = () => { visible = false; schedule(); };
    const pageshow = () => { visible = true; schedule(); };
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      const nextVisible = entries[0].isIntersecting;
      if (nextVisible === visible) return;
      visible = nextVisible;
      schedule();
    }) : null;
    if (sayings.length) bubble.textContent = sayings[0];
    bubble.hidden = !sayings.length;
    toggle.hidden = false;
    toggle.addEventListener('click', click);
    document.addEventListener('visibilitychange', schedule);
    window.addEventListener('pagehide', pagehide);
    window.addEventListener('pageshow', pageshow);
    observer?.observe(host);
    controllers.set(host, () => {
      clearTimeout(timer);
      observer?.disconnect();
      toggle.removeEventListener('click', click);
      document.removeEventListener('visibilitychange', schedule);
      window.removeEventListener('pagehide', pagehide);
      window.removeEventListener('pageshow', pageshow);
      controllers.delete(host);
    });
    schedule();
  }
  const start = root => root.querySelectorAll('[data-tzero-performance]').forEach(mount);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(document), {once: true});
  else start(document);
  document.addEventListener('shopify:section:load', event => start(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-tzero-performance]').forEach(host => controllers.get(host)?.());
  });
})();
